import { UploadFile } from 'antd';
import { UploadArchiveResult } from '../../archive/Archive/Archive.types';

export enum TransactionType {
  debit = 'domain.enums.transaction_type.debit',
  credit = 'domain.enums.transaction_type.credit',
}

export enum InstallmentType {
  accountPayable = 'domain.enums.account_type.payable',
  accountReceivable = 'domain.enums.account_type.receivable',
}

export interface ReadTransactionsFileFormValues {
  file: UploadFile<UploadArchiveResult>;
  bankAccountId: number;
}

export interface ReadTransactionsRequest {
  bankAccountId: number;
  file: File;
}

export interface BankConciliationReadTransactionsResponse {
  bankAccountId: number;
  transactionsWithInstallments: TransactionsWithInstallment[];
}

export interface TransactionsWithInstallment {
  transaction: Transaction;
  installmentReceivables: InstallmentsTransaction[];
  installmentPayables: InstallmentsTransaction[];
}

export interface Transaction {
  isChecked: boolean;
  type: TransactionType;
  value: number;
  name: string;
  payDate: string;
  transactionId: string;
}

export interface InstallmentsTransaction {
  installmentId: number;
  accountId: number;
  codeIdentifier: string;
  installmentValue: number;
  dueDate: string;
  type: InstallmentType;
  isChecked: boolean;
  favored: string;
}

export interface Conciliate {
  transaction: Transaction;
  installmentId: number;
  codeIdentifier: string;
  installmentValue: number;
  type: InstallmentType;
}

export interface TransactionData {
  type: TransactionType;
  value: number;
  name: string;
  payDate: string;
  transactionId: string;
  installments: InstallmentsTransaction[];
}

export interface ConciliatesInstallments {
  installmentId: number;
  type: InstallmentType;
}

export interface ConciliatesRequest {
  conciliates: ConciliateRequest[];
}

export interface ConciliateRequest {
  type: TransactionType;
  value: number;
  name: string;
  payDate: string;
  transactionId: string;
  installments: ConciliatesInstallments[];
}
